<template>
	<div>
		<el-dialog :visible.sync="visible"
			:title="$t('retailInstance.text.batchClose')"
			:close-on-click-modal="false"
			:before-close="handleClose" class="bind-dialog  create-host">
			<batch-instance-table v-bind="$attrs" :multipleSelection="multipleSelection">
			</batch-instance-table>
			<div slot="footer">
				<el-button @click="cancelBind">
					{{ $t('privateNetInstance.cancel') }}
				</el-button>
				<el-button @click="sureBind"
					type="primary">
					{{ $t('privateNetInstance.bindSure') }}
				</el-button>
			</div> 
		</el-dialog>
		<jcb-opt-protect 
				:visible.sync="operationProtectVisible" 
				:action-type="OperationConstant.BATCH_STOP"
				@success="onSuccess" @error="onError">
		</jcb-opt-protect>
	</div>
</template>

<script>
import BatchInstanceTable from '@/components/common/BatchInstanceTable';
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';
export default {
	name: 'BatchClose',
	mixins: [operationProtect],
    components: {
        BatchInstanceTable
    },
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		multipleSelection: {
			type: Array,
			default: []
		},
		region: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			operationProtectVisible: false,
		};
	},
	computed: {
		OperationConstant: () => OperationConstant
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
		},
		cancelBind() {
			this.handleClose();
		},
		sureBind() {
			this.openOperationProtect(OperationConstant.BATCH_STOP, this.multipleSelection, this.region);
			this.handleClose();
		},
		stopBatch(headers) {
			let sourceHeaders={'Content-Type': 'application/json'};
			let instanceIds = this.multipleSelection.map(item => item.instanceId)
			const params = {
				region: this.region,
				instanceIds
			};

			Ajax.put('/api/cps/stopInstances', params,{
				headers: Object.assign({}, headers, sourceHeaders)
			})
			.then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
				this.$emit('refresh');
			});
		}
	},
};
</script>

<style lang="scss" scoped>
	.bind-dialog {

		.chooseInfo {
			margin-bottom: 5px;
			font-size: 12px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BatchClose.vue